import { EMAIL_ATTACHMENT_TABLE_CONSTANTS } from "routes/email/EmailAttachmentTableV3";
import { get } from "lodash";
import { useQuery } from "@tanstack/react-query";
import UserService from "services/User";
import { useMemo } from "react";
import { getEmailAttachmentsTableFilters } from "routes/email/components/EmailAttachmentsTableColumnsAndFilters";
import { getEmailAttachmentsTableColumns } from "routes/email/components/EmailAttachmentsTableColumnsAndFilters";
import { queryClient } from "App";
import { addResizedColumns } from "./useTableConfig";

export const invalidateEmailAttachmentTableQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [EMAIL_ATTACHMENT_TABLE_CONSTANTS.queryKey],
  });
};

export const useEmailAttachmentTable = ({ tableName = null }) => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const filters = useMemo(() => {
    return getEmailAttachmentsTableFilters();
  }, []);

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getEmailAttachmentsTableColumns();

    const emailAttachmentsTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${tableName}`,
      {}
    );

    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: emailAttachmentsTableSettings?.resized_columns || {},
    });

    return withResizedColumns;
  }, [tableSettings, isTableSettingsFetched, tableName]);

  return { filters, columns };
};
